/** MuJoCo fixed tendons require at least two distinct joint references (see sanitize in tendonActions). */

export function countUniqueTendonJointMembers(joints) {
  const seen = new Set();
  for (const entry of joints || []) {
    if (entry?.joint) seen.add(entry.joint);
  }
  return seen.size;
}

/** Whether removing the row at `index` would still leave ≥2 unique joint members. */
export function canRemoveTendonMemberAt(joints, index) {
  const list = joints || [];
  if (!Number.isInteger(index) || index < 0 || index >= list.length) return false;
  const next = list.filter((_, i) => i !== index);
  return countUniqueTendonJointMembers(next) >= 2;
}
